import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// elementui
import ElementUI from "element-plus";
import "element-plus/dist/index.css"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import Cookies from "js-cookie"
import axios from "axios";
import Global from "./utils/global.js"

const app = createApp(App);

//这两个值好像默认就是这样了，所以不重要，重点是最后一个设置
axios.defaults.xsrfCookieName = 'csrfmiddlewaretoken'
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'
//重点！！！设置请求获取cookie
axios.defaults.withCredentials = true
axios.get('/lzjaiopsbase/getcsrf/',{withCredentials: true})
        .then((response) => {
          console.log(response)
          Cookies.set("DjangoCookie",Cookies.get('csrftoken'))
        })

// 全局注册
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
//实例化
app.use(router).use(store).use(ElementUI).use(Global).mount("#app");
